import { CHANGE_BRAND, SET_DIRTY_STATE } from '../constants/actionTypes';

const INITIAL_STATE = {
    isDirty: false,
    brandId: parseInt(localStorage.getItem('selectedBrandId'))
};

export default function analytics(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CHANGE_BRAND:
            localStorage.setItem('selectedBrandId', action.payload.brandId);
            return { ...state, brandId: action.payload.brandId }
        case SET_DIRTY_STATE:
            return {
                ...state,
                isDirty: action.payload.isDirty
            }
        default:
            return state;
    }
}